import BrowserInfo from "./lib/browserInfo";
export default { BrowserInfo: BrowserInfo };
new BrowserInfo({
    app: {
        name: "My App",
        language: "en"
    },
    credentials: {
        mdn: "123456789",
        pk: "123456789"
    },
    encrypt: function (key, value) { return value; },
    location: {
        ip: "",
        latitude: "",
        longitude: ""
    }
}).get();
